// extracted by mini-css-extract-plugin
export default {"root":"LoanProgramCard_root__e+sf6","title":"LoanProgramCard_title__fXW4k"};